import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "paperclip",
  "use": "paperclip-usage",
  "viewBox": "0 0 21 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 18\" id=\"paperclip\">\n  <path fill-rule=\"evenodd\" d=\"M150.4,468.572l-0.1-.091a5.845,5.845,0,0,0-7.806.061l-9.943,9.315A4.844,4.844,0,0,0,131,480.98a3.87,3.87,0,0,0,1.257,2.841A4.422,4.422,0,0,0,135.295,485h0a4.423,4.423,0,0,0,3.038-1.18l8.583-8.039a2.7,2.7,0,0,0,0-4,3.17,3.17,0,0,0-4.273,0l-6.574,6.158a0.816,0.816,0,0,0-.269.6,0.873,0.873,0,0,0,.9.843,0.931,0.931,0,0,0,.636-0.247h0l6.58-6.164a1.315,1.315,0,0,1,1.728,0,1.092,1.092,0,0,1,0,1.618l-8.583,8.039a2.572,2.572,0,0,1-1.765.686h0a2.569,2.569,0,0,1-1.765-.686,2.245,2.245,0,0,1-.73-1.648,3.309,3.309,0,0,1,1.029-1.93l9.943-9.316a3.955,3.955,0,0,1,5.291-.033l0.095,0.09a3.375,3.375,0,0,1-.059,4.934l-8.23,7.708a0.819,0.819,0,0,0-.267.6,0.873,0.873,0,0,0,.9.843,0.929,0.929,0,0,0,.635-0.247h0l8.234-7.713A4.989,4.989,0,0,0,150.4,468.572Z\" transform=\"translate(-131 -467)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/paperclip.svg
// module id = null
// module chunks = 